import strings from '../../../../../../common/Translation/Translate';
import { FormModel } from '../../../../../../components/Form';

export const MediaInfoForm = (): FormModel[] => {
  return [
    {
      label: strings.organization_text_image,
      value: '',
      type: 'upload',
      accept: 'image/*',
      placeholder: '',
      field: 'image',
      validators: [],
      responsive: { xs: 12, md: 6 },
      required: false,
      multiline: false,
    },
    {
      label: strings.organization_text_logo,
      value: '',
      type: 'upload',
      accept: 'image/*',
      placeholder: '',
      field: 'organizationLogo',
      validators: [],
      sx: { alignSelf: 'flex-start' },
      responsive: { xs: 12, md: 6 },
      required: false,
      multiline: false,
    },

  ];
};
